export default function StarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.00128 1.302C5.77123 1.302 5.53618 1.427 5.43615 1.682L4.23588 4.617L1.06514 4.847C0.520018 4.887 0.299968 5.567 0.720065 5.922L3.14562 7.967L2.38545 11.042C2.28543 11.457 2.6105 11.802 2.98059 11.802C3.08561 11.802 3.19564 11.772 3.30066 11.707L6.00128 10.037L8.70191 11.707C8.80693 11.772 8.91696 11.802 9.02198 11.802C9.39207 11.802 9.71714 11.457 9.61712 11.042L8.85694 7.967L11.2825 5.922C11.7026 5.567 11.4776 4.887 10.9324 4.847L7.76669 4.617L6.56641 1.682C6.46639 1.427 6.23134 1.302 6.00128 1.302Z"
        fill="currentColor"
      />
    </svg>
  );
}
